import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchOnboardingStatus } from "./api"

export function useFetchOnboardingStatus({ enabled = true }: { enabled?: boolean } = {}) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["onboarding"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return fetchOnboardingStatus(context)
    },
    retry: false,
    enabled,
  })
}
